import React, { FC, useId } from 'react';
import { HeadingBlock } from '@design-system/heading-block';
import useJoiValidation from '@root/hooks/useJoiValidation';
import { Keyboard, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { SintomasPicotSliderProps } from './models';
import { SintomasPicotSliderSchema } from './SintomasPicotSlider.schema';

import './SintomasPicotSlider.scss';

const SintomasPicotSlider: FC<SintomasPicotSliderProps> = ({ title, items }) => {
  const { data } = useJoiValidation(SintomasPicotSliderSchema, 'SintomasPicotSliderSchema', {
    title,
    items,
  });
  const uid = useId();

  return (
    <section className="sintomas-picot-slider">
      {data.title ? (
        <HeadingBlock
          className="sintomas-picot-slider__heading"
          headline={data.title}
          headlineTag="h2"
          headlineSize="m"
        />
      ) : null}
      <Swiper
        modules={[Keyboard, Pagination]}
        pagination={{
          clickable: true,
        }}
        keyboard={{
          enabled: true,
          onlyInViewport: true,
        }}
        spaceBetween={0}
        slidesPerView="auto"
        centeredSlides
        initialSlide={0}
        className="sintomas-picot-swiper"
        breakpoints={{
          768: {
            spaceBetween: 80,
          },
        }}
      >
        {data.items.map((item) => (
          <SwiperSlide tabIndex={0} key={`slide-${uid}-${item.title}`}>
            <img src={item.mainImage} alt={item.alt} className="main-image" />
            <h3>{item.title}</h3>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default SintomasPicotSlider;
